import * as React from "react";
import { useContext, useMemo } from "react";
import Popover from "components/common/Popover";
import useView from "views/hooks/useView";
import SearchExplainContext from "views/components/contexts/SearchExplainContext";
import { IconButton } from "components/common";
const WidgetWarmTierAlert = ({ activeQuery, widgetId }) => {
  const { getExplainForWidget } = useContext(SearchExplainContext);
  const view = useView();
  const explainedWidget = getExplainForWidget(activeQuery, widgetId, view.widgetMapping);
  const isWidgetInWarmTier = useMemo(
    () => explainedWidget == null ? void 0 : explainedWidget.searched_index_ranges.some((range) => range.is_warm_tiered),
    [explainedWidget == null ? void 0 : explainedWidget.searched_index_ranges]
  );
  if (!isWidgetInWarmTier) return null;
  return /* @__PURE__ */ React.createElement(Popover, { position: "bottom" }, /* @__PURE__ */ React.createElement(Popover.Target, null, /* @__PURE__ */ React.createElement(IconButton, { title: "Info", name: "info" })), /* @__PURE__ */ React.createElement(Popover.Dropdown, { title: "Info" }, "This widget is retrieving data from the Warm Tier and may take longer to load."));
};
export default WidgetWarmTierAlert;
